import { useEffect, useState } from 'react';
import { Box, Divider, Fade, Grid, IconButton, Modal, Paper, Typography } from '@mui/material';
import { TextWithLabelInline } from '@main/components';
import WdSvgIcon from '@main/core/WdSvgIcon';
import _ from 'lodash';
import './customScrollbar.css';

export const RepositoryConnection = ({
  title,
  show = false,
  onHide = () => {},
  data = {},
  selected,
}) => {
  const [selectedData, setSelectedData] = useState(undefined);
  const [description, setDescription] = useState('');

  const handleCloseModal = () => {
    onHide();
  };

  useEffect(() => {
    if (selected === undefined || _.isEmpty(data)) return;
    const selectingData = data[selected] || {};
    setSelectedData(selectingData);
    setDescription(data[selected]?.description || '');
  }, [selected, data]);

  return (
    <Modal
      open={show}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      className="flex justify-center items-center pt-32"
      onClose={handleCloseModal}
    >
      <Fade in={show}>
        <Box className="flex mx-4 my-4 md:my-0">
          <Paper
            className="flex flex-col relative w-full md:w-auto custom-scrollbar"
            elevation={3}
            sx={{
              minWidth: '48rem',
              minHeight: '20rem',
              maxWidth: '100rem',
              maxHeight: 'calc(100vh - 8rem)', // Ajustar la altura máxima
              overflow: 'scroll',
            }}
          >
            <div className="flex justify-end p-8 absolute top-0 right-0">
              <IconButton aria-label="close" size="small" onClick={handleCloseModal}>
                <WdSvgIcon className="text-32" size={24} color="action">
                  material-solid:close
                </WdSvgIcon>
              </IconButton>
            </div>
            <div className="container p-20">
              <Typography variant="h6" className="flex justify-center">
                {title}
              </Typography>
              <Typography className="flex justify-center pb-14 font-bold text-lg">{`"${selected}"`}</Typography>
              <div className="flex justify-center pb-14 font-bold text-lg">
                {description && <TextWithLabelInline label="Descripción" value={description} />}
              </div>

              <Divider />
              <Box className="mx-24">
                <Grid container spacing={2}>
                  {selectedData?.api && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        API
                      </Typography>
                      <TextWithLabelInline label="Repositorio" value={selectedData.api.repo} />
                      {/* <TextWithLabelInline label="Last Name" value={selectedData.api.lastName} /> */}
                      {/* <TextWithLabelInline label="Name" value={selectedData.api.name} /> */}
                      {/* <TextWithLabelInline label="Owner" value={selectedData.api.owner} /> */}
                      <TextWithLabelInline label="Tag" value={selectedData.api.tag} />
                    </Grid>
                  )}
                  {selectedData?.manager && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        Manager
                      </Typography>
                      <TextWithLabelInline label="Repositorio" value={selectedData.manager.repo} />
                      {/* <TextWithLabelInline
                        label="Last Name"
                        value={selectedData.manager.lastName}
                      /> */}
                      {/* <TextWithLabelInline label="Owner" value={selectedData.api.owner} /> */}
                      <TextWithLabelInline label="Tag" value={selectedData.manager.tag} />
                    </Grid>
                  )}
                  {selectedData?.notify && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        Notify
                      </Typography>
                      <TextWithLabelInline label="Repositorio" value={selectedData.notify.repo} />
                      {/* <TextWithLabelInline label="Last Name" value={selectedData.notify.lastName} /> */}
                      {/* <TextWithLabelInline label="Owner" value={selectedData.api.owner} /> */}
                      <TextWithLabelInline label="Tag" value={selectedData.notify.tag} />
                      {/* <TextWithLabelInline label="NodeJS" value={selectedData.notify.nodejs} /> */}
                    </Grid>
                  )}
                  {selectedData?.terminals && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        Terminals
                      </Typography>
                      <TextWithLabelInline
                        label="Repositorio"
                        value={selectedData.terminals.repo}
                      />
                      {/* <TextWithLabelInline
                        label="Last Name"
                        value={selectedData.terminals.lastName}
                      /> */}
                      {/* <TextWithLabelInline label="Name" value={selectedData.api.name} />
                      <TextWithLabelInline label="Owner" value={selectedData.api.owner} /> */}
                      <TextWithLabelInline label="Tag" value={selectedData.terminals.tag} />
                    </Grid>
                  )}
                  {selectedData?.['face-recognition-server'] && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        Face Recognition Server
                      </Typography>
                      <TextWithLabelInline
                        label="Repositorio"
                        value={selectedData['face-recognition-server'].repo}
                      />
                      <TextWithLabelInline
                        label="Tag"
                        value={selectedData['face-recognition-server'].tag}
                      />
                    </Grid>
                  )}
                  {selectedData?.['fingerprint-recognition-server'] && (
                    <Grid item xs={12} md={4}>
                      <Typography variant="subtitle1" className="pt-14 text-center">
                        Fingerprint Recognition Server
                      </Typography>
                      <TextWithLabelInline
                        label="Repositorio"
                        value={selectedData['fingerprint-recognition-server'].repo}
                      />
                      <TextWithLabelInline
                        label="Tag"
                        value={selectedData['fingerprint-recognition-server'].tag}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            </div>
          </Paper>
        </Box>
      </Fade>
    </Modal>
  );
};
